// extracted by mini-css-extract-plugin
export var activeFilterButton = "_j8-c";
export var backButton = "_j8-4";
export var backIcon = "_j8-5";
export var chevronShortcut = "_j8-6";
export var container = "_j8-1";
export var editor = "_j8-8";
export var editorWrapper = "_j8-7";
export var prefix = "_j8-2";
export var searchIcon = "_j8-3";
export var suffix = "_j8-9";
export var suffixContent = "_j8-a";
export var suffixText = "_j8-b";
export var wrapper = "_j8-0";